export default __webpack_public_path__ + "static/10-5b5d0be14a71a4d25b44cfa4ad2a6f47.png";